import { Dialog, IconButton, Toolbar } from "@mui/material"
import { LandmarkType, Photo } from "../types"

import CloseIcon from '@mui/icons-material/Close';
import { useCallback, useLayoutEffect, useState } from "react";
import { photoUrl } from "@/src/services";

interface PhotoPreviewProps {
    photo?: Photo,
    open: boolean,
    onClose: () => void,
}


export const PhotoPreview = ({ photo, open, onClose }: PhotoPreviewProps) => {

    const [canvas, setCanvas] = useState<HTMLCanvasElement>()
    const setCanvasCallback = useCallback((canvas: HTMLCanvasElement) => {
        setCanvas(canvas)
    }, [])

    useLayoutEffect(() => {

        if (photo && canvas) {
            const ctx = canvas.getContext("2d")
            if (!ctx) throw new Error("canvas.getContext failed");
            const image = new Image()
            image.src = photoUrl(photo, "normal")

            image.onload = () => {

                console.log(photo)
                canvas.width = image.naturalWidth;
                canvas.height = image.naturalHeight;
                ctx.drawImage(image, 0, 0);
                if (photo.metadata) {
                    const faces = photo.metadata.DetectFaces.FaceDetails;
                    faces.forEach(face => {
                        ctx.beginPath();
                        ctx.rect(face.BoundingBox.Left * canvas.width, face.BoundingBox.Top * canvas.height, face.BoundingBox.Width * canvas.width, face.BoundingBox.Height * canvas.height);
                        ctx.stroke();
                    })

                    faces.forEach((face) => {
                        const landmarks: { [key in LandmarkType]?: { x: number, y: number } } = Object.fromEntries<{ x: number, y: number }>(
                            face.Landmarks.map(landmark => [landmark.Type, { x: landmark.X * canvas.width, y: landmark.Y * canvas.height }]))
                        // const eyesRectangle = { x: landmarks.leftEyeLeft.x, y: landmarks.leftEyeLeft.y, width: landmarks.rightEyeRight.x - landmarks.leftEyeLeft.x, height: landmarks.rightEyeRight.y - landmarks.leftEyeLeft.y }
                        const {
                            leftEyeLeft, leftEyeDown, leftEyeUp, rightEyeRight, rightEyeDown, rightEyeUp,
                            leftEyeBrowLeft, rightEyeBrowRight, leftEyeBrowUp, rightEyeBrowUp,
                        } = landmarks;

                        if (leftEyeLeft && leftEyeDown && leftEyeUp && rightEyeRight && rightEyeDown && rightEyeUp) {
                            ctx.strokeStyle = "red";
                            ctx.beginPath();
                            ctx.moveTo(leftEyeLeft.x, leftEyeUp.y);
                            ctx.lineTo(rightEyeRight.x, rightEyeUp.y);
                            ctx.lineTo(rightEyeRight.x, rightEyeDown.y);
                            ctx.lineTo(leftEyeLeft.x, leftEyeDown.y);
                            ctx.closePath()
                        }
                        // ctx.moveTo(landmarks.leftEyeLeft.x, landmarks.leftEyeLeft.y);
                        // ctx.lineTo(landmarks.rightEyeRight.x, landmarks.rightEyeRight.y);

                        ctx.stroke();
                    })

                }
            }
        }

    }, [photo, canvas])


    return (
        <Dialog maxWidth="lg" fullWidth open={open} onClose={onClose}>

            <Toolbar variant="dense" disableGutters>
                <IconButton onClick={(e) => onClose()}>
                    <CloseIcon />
                </IconButton>
            </Toolbar>
            <canvas ref={setCanvasCallback} />

        </Dialog>
    )
}